module.exports = __webpack_public_path__ + "img/staking-success.970db962.svg";